window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoBonusMaratonRepo = function () {

    var url = 'api/casinobonusmaraton';

    var rezultati = function () {
        return fetch(url, {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    var rezultatiIgrac = function (playerId) {
        return fetch(url + casino.repos.base.serializeGetParams({
            playerId: playerId
        }), {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        rezultati: rezultati,
        rezultatiIgrac: rezultatiIgrac
    }

}();